import { __decorate } from "tslib";
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { classNames } from '@microsoft/fast-web-utilities';
import { wasClickOutsideElement } from '../utils';
import { foundationDropdownMenuStyles as styles } from './dropdown-menu.styles';
import { foundationDropdownMenuTemplate as template } from './dropdown-menu.template';
/**
 * @tagname %%prefix%%-dropdown-menu
 */
export class DropdownMenu extends FoundationElement {
    constructor() {
        super(...arguments);
        this.autoClose = true;
        this.disabled = false;
        this.name = 'Dropdown Menu';
        this.open = false;
        this.clickOutside = (e) => this.handleClickOutside(e);
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('onMenuClick', this.onDropdownMenuItemClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('mousedown', this.clickOutside);
    }
    handleClickOutside(event) {
        if (wasClickOutsideElement(event, this)) {
            this.open = false;
        }
    }
    openChanged() {
        this.classNames = classNames(['hidden', !this.open]);
        if (this.open) {
            document.addEventListener('mousedown', this.clickOutside);
        }
        else {
            document.removeEventListener('mousedown', this.clickOutside);
        }
    }
    toggleDropdownMenuVisibility() {
        this.open = !this.open;
    }
    onDropdownMenuItemClick() {
        if (this.autoClose)
            this.open = false;
    }
    get allItems() {
        return this.items;
    }
}
__decorate([
    observable
], DropdownMenu.prototype, "items", void 0);
__decorate([
    attr({ attribute: 'auto-close', mode: 'boolean' })
], DropdownMenu.prototype, "autoClose", void 0);
__decorate([
    attr({ attribute: 'disable-button', mode: 'boolean' })
], DropdownMenu.prototype, "disabled", void 0);
__decorate([
    observable
], DropdownMenu.prototype, "classNames", void 0);
__decorate([
    attr
], DropdownMenu.prototype, "name", void 0);
__decorate([
    attr({ attribute: 'open', mode: 'boolean' })
], DropdownMenu.prototype, "open", void 0);
__decorate([
    attr
], DropdownMenu.prototype, "buttonAppearance", void 0);
/**
 * The Foundation Dropdown Menu
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-dropdown-menu\>
 */
export const foundationDropdownMenu = DropdownMenu.compose({
    baseName: 'dropdown-menu',
    styles,
    template,
});
